var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.flag)?_c('vue-apex-charts',{attrs:{"type":"area","height":"500","width":"100%","options":_vm.option3,"series":_vm.option3.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }